module.exports = __webpack_public_path__ + "img/Monte_Kope_77.73f2e64f.jpg";